export const ServiceIds = {
    CONFIG: Symbol.for('CONFIG'),
    FEATURE_FLAG_LOADER: Symbol.for('FEATURE_FLAG_LOADER'),
    FEE_SERVICE: Symbol.for('FEE_SERVICE'),
    VAT_SERVICE: Symbol.for('VAT_SERVICE'),
    FB_ADAPTER: Symbol.for('FB_ADAPTER'),
    GOOGLE_SIGN_IN: Symbol.for('GOOGLE_SIGN_IN'),
};
